import {StripeCardSummary} from "../types/TfStripeTypes";

export type CardCreateResult = StripeCardCreateSuccess | StripeCardCreateFailure;

export abstract class StripeCardCreateResult {

    protected constructor(protected success: boolean) {

    }

    public isSuccess(): this is StripeCardCreateSuccess {
        return this.success;
    }

    public isFail(): this is StripeCardCreateFailure {
        return !this.success;
    }

    public static success(card: StripeCardSummary): StripeCardCreateSuccess {
        return StripeCardCreateSuccess.of(card);
    }

    public static failure(reason: string): StripeCardCreateFailure {
        return StripeCardCreateFailure.of(reason);
    }
}

export class StripeCardCreateSuccess extends StripeCardCreateResult {

    private constructor(public card: StripeCardSummary) {
        super(true);
    }

    public static of(card: StripeCardSummary): StripeCardCreateSuccess {
        return new StripeCardCreateSuccess(card);
    }
}

export class StripeCardCreateFailure extends StripeCardCreateResult {

    private constructor(public reason: string) {
        super(false);
    }

    public static of(reason: string): StripeCardCreateFailure {
        return new StripeCardCreateFailure(reason);
    }
}
